import {JsonObject, JsonProperty} from 'json2typescript';
import {Respondent} from './respondent';

@JsonObject('Device')
export class Device {

    @JsonProperty('id',Number)
    id = 0;

    @JsonProperty('name',String)
    name = '';

    @JsonProperty('macAddress',String)
    macAddress = '';

    @JsonProperty('ipAddress',String,true)
    ipAddress = '';

    @JsonProperty('createdDate',String)
    createdDate = '';

    @JsonProperty('respondents',[Respondent],true)
    respondents: Respondent[] = [];

    @JsonProperty('expanded',Boolean,true)
    expanded:boolean;

    // TODO: remove this tis is not useful when you can get the length of an array
    @JsonProperty('totalNumberOfRespondents',Number)
    totalNumberOfRespondents:number;

    constructor() {
    }

}
